// @ts-nocheck
import React, { useState, useEffect, useMemo, useContext, useCallback } from 'react';
import Router, { useRouter } from 'next/router';
import * as Enums from '@/utils/enums';
import Helper from '@/utils/helper';
import PS from '@/services/permission/permission-service';
import Breadcrumbs from '@/components/breadcrumbs';
import Storage from '@/utils/storage';
import SettingsMenu from '@/components/settings/menu';
import { Box, Card, Space, Tabs, Tooltip } from "@mantine/core";
import InventoryTable from "@/PageComponents/Table/Component Tables/InventoryTable";
import InventoryCategoriesTable from "@/PageComponents/Table/Component Tables/InventoryCategoriesTable";
import InventorySubcategoriesTable from "@/PageComponents/Table/Component Tables/InventorySubcategoryTable";
import InventorySupplierTable from "@/PageComponents/Table/Component Tables/InventorySupplierTable";
import SCMessageBarContext from '@/utils/contexts/sc-message-bar-context';
import constants from '@/utils/constants';
import tabStyles from '@/styles/Tabs.module.css';
import { useQuery } from "@tanstack/react-query";
import { FieldSetting, getFieldSettings } from "@/PageComponents/Settings/Field Settings/FieldSettings";
import { getSystemNameForFormName } from "@/PageComponents/Settings/Field Settings/fieldSettingHelper";
import { colors, layout } from '@/theme';
import InventoryUnitTable from '@/PageComponents/Settings/Inventory/InventoryUnitTable';
import InventoryGeneralSettings from '@/PageComponents/Settings/Inventory/InventoryGeneralSettings';
import WarehouseTable from '@/PageComponents/Table/Component Tables/WarehouseTable';
import featureService from '@/services/feature/feature-service';
import { createFileRoute } from '@tanstack/react-router'




function InventorySettings() {

    const messageBarContext = useContext(SCMessageBarContext);

    const router = useRouter()

    const [hasStockControl, setHasStockControl] = useState<boolean | undefined>();
    const [hasVanStock, setHasVanStock] = useState<boolean | undefined>();
    const [hasVanManagePermission] = useState(PS.hasPermission(Enums.PermissionName.VanManage));

    const tabData = useMemo(() => {
        let opts: any = {
            inventory: {
                label: 'General Settings',
                access: true
            },
            unit: {
                label: 'Units of Measurement',
                access: true,
                disabled: false,
            }
        };
        if (hasStockControl) {
            opts.warehouse = {
                label: "Warehouses",
                access: hasStockControl
            }
        }
        if (hasVanStock) {
            opts.van = {
                label: "Vans",
                access: hasVanManagePermission
            }
        }
        return opts;
    }, [hasStockControl, hasVanStock, hasVanManagePermission])

    const [accessStatus, setAccessStatus] = useState(Enums.AccessStatus.None);

    const getAccessStatus = () => {
        let subscriptionInfo = Storage.getCookie(Enums.Cookie.subscriptionInfo);
        if (subscriptionInfo) {
            setAccessStatus(subscriptionInfo.AccessStatus);
        }
    };

    useEffect(() => {
        getAccessStatus();
        featureService.getFeature(constants.features.STOCK_CONTROL).then((feature: any) => {
            setHasStockControl(!!feature);
        });
        featureService.getFeature(constants.features.VAN_STOCK).then((feature: any) => {
            setHasVanStock(!!feature);
        });
    }, []);

    useEffect(() => {
        if (accessStatus === Enums.AccessStatus.LockedWithOutAccess) {
            Helper.nextRouter(Router.replace, "/");
        }
    }, [accessStatus]);

    useEffect(() => {
        const tab = router.asPath.split('?tab=')[1]
        if (tab && tabData[tab]) {
            setActiveTab(tab)
        }
    }, [tabData]);


    const [activeTab, setActiveTab] = useState<string | null>(Object.entries(tabData).find(([, x]: any) => (x as any).access)?.[0] || 'inventory');

    const handleTabChange = (newTabName: string | null) => {
        
        router.replace(router.asPath.split('?')[0] + '?tab=' + newTabName);
        // because warehouse and van use the same table component we need to reset the activeTab to force a re-render
        if (newTabName === 'warehouse' || newTabName === 'van') {
            setActiveTab("")
            setTimeout(() => {
                setActiveTab(newTabName);
            }, 0); // Delay to ensure the table is rendered before fetching data
        }
        else {
            setActiveTab(newTabName)
        }
    }

    const tabs = <>
        <Tabs color={'scBlue'} value={activeTab} onChange={handleTabChange}
            classNames={{
                tab: tabStyles.scTab,
                list: tabStyles.scTabList,
                tabLabel: tabStyles.scTabLabel
            }}
        >
            <Tabs.List mb={0} pb={0}>
                {
                    Object.entries(tabData).filter(([, x]: any) => true).map(
                        ([tabName, d]: any) => d &&
                            <Tooltip label={d.disabledLabel || ''}
                                key={tabName + 'tab'}
                                position={'bottom'}
                                disabled={!d.disabled || !d.disabledLabel}
                                color={'scBlue'}
                                openDelay={1000}
                                events={{ hover: true, focus: true, touch: true }}
                            >
                                <Tabs.Tab value={tabName}
                                    disabled={!d.access || d.disabled}
                                >{d.label}</Tabs.Tab>
                            </Tooltip>
                    )
                }
            </Tabs.List>
        </Tabs>
    </>

    return (
        <div className="settings-container">
            <div className="row">
                <SettingsMenu urlPath={router.asPath} />
                <div className="settings-card">
                    {tabs}
                    <>
                        <Box
                        >
                        </Box>
                        <Box
                        >
                            <Card
                                style={{
                                    backgroundColor: 'white'
                                }}
                                p={'var(--mantine-spacing-md)'}
                                radius={'md'}
                            >
                                {
                                    activeTab === 'inventory' &&
                                    <InventoryGeneralSettings /> ||
                                    activeTab === 'unit' &&
                                    <InventoryUnitTable /> ||
                                    activeTab === "warehouse" &&
                                    <WarehouseTable warehouseType={Enums.WarehouseType.Warehouse}/> ||
                                    activeTab === "van" &&
                                    <WarehouseTable warehouseType={Enums.WarehouseType.Mobile}/>
                                }
                            </Card>
                        </Box>

                    </>
                </div>
            </div>

                            <Space h={80} />
            <style jsx>{`
        .row {
          display: flex;
          justify-content: space-between;
        }
        .column {
          display: flex;
          flex-direction: column;
          width: ${layout.inputWidth};
        }
        .column-end {
          align-items: flex-end;
        }
        .column-margin {
          margin-left: 24px;
        }
       
        .title {
          color: ${colors.darkPrimary};
          position: relative;
          width: 100%;
        }
        .title h1 {
          font-size: 24px;
          margin: 6px 0 2rem 0;
        }
        .title p {
          font-size: 14px;
          margin: 0;
        }
        .section-title {
          background-color: ${colors.background};
          border-radius: ${layout.cardRadius};
          box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
          color: ${colors.bluePrimary};
          font-size: 1.25rem;
          font-weight: bold;
          margin-top: 2rem;
          opacity: 0.9;
          padding: 1rem;
        }
        .small-title {
          color: ${colors.white};
          font-size: 0.875rem;
          font-weight: bold;
          margin-top: 2rem;
        }
        .container :global(.input-container) {
          width: 50%;
        }
        .title :global(.save) {
          margin: 0;
          position: absolute;
          right: 0;
          top: 0;
        }
      `}</style>
        </div>
    )
}

export default InventorySettings;

export const Route = createFileRoute('/_authenticated/settings/inventory/manage')({ component: InventorySettings })
